export const namespace = (actionType: string): string => `form/${actionType}`;

export const INITIALIZE_DATAKEY = namespace('INITIALIZE_DATAKEY');

// Model setters
export const SET_MODEL = namespace('SET_MODEL');
export const SET_MODEL_PROPERTY = namespace('SET_MODEL_PROPERTY');

// Interaction handlers
export const SET_FOCUSED = namespace('SET_FOCUSED');
export const SET_BLURRED = namespace('SET_BLURRED');
export const RESET_DIRTY_STATE = namespace('RESET_DIRTY_STATE');
export const RESET_ALL_DIRTY_STATES = namespace('RESET_ALL_DIRTY_STATES');
export const SET_ALL_DIRTY_STATES_BLURRED = namespace('SET_ALL_DIRTY_STATES_BLURRED');
